<div>


  <div class="nav-under container-fluid header-borders border-bottom py-2">

    <nav aria-label="breadcrumb">
      <ol class="breadcrumb bg-white page-title">
        <li class="breadcrumb-item">App Content</li>
        <li class="breadcrumb-item active" aria-current="page"><a routerLink="/animal">Animals</a></li>
        <li class="breadcrumb-item" aria-current="page">{{animalName}}</li>
      </ol>
    </nav>
  </div>

    <div class="tabs border-bottom">
      <a class="tab-link active" (click)="openCity($event, 'about')">About</a>
      <a class="tab-link" (click)="openCity($event, 'animal')">Animal Info</a>
      <a class="tab-link" (click)="openCity($event, 'disease')">Diseases</a>
      <a class="tab-link" (click)="openCity($event, 'pest')">Parasites</a>
    </div>

    <div class="container-fluid">
    <div id="about" class="tabcontent container-fluid">
      <div class="py-2">
      <h3 class="page-subtitle">About {{animalName}}</h3>
      </div>
      <p class="alert alert-danger" *ngIf="editError">{{ message }}</p>
      <form (ngSubmit)="updateAnimal(createAnimalForm.value)" #createAnimalForm="ngForm"
              class="py-2">
              <div class="row">
                <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Animal Name</label>
                  <input type="text" class="form-control change-input-field" placeholder="name of animal" name="name"
                  ngModel #name="ngModel" [(ngModel)]="animalName" minlength="3" readonly/>
                </div>

                <div class="form-group">
                  <label for="name">About Animal</label>
                  <quill-editor
                    name="description"
                    #description="ngModel"
                    [(ngModel)]="animalDescription"
                    [modules]="quillConfig"
                    (onEditorChanged)="clearErrorMessage(description)"
                    [styles]="editorStyle"
                  >
                  </quill-editor>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-6">
                      <img src='{{ "https://storage.googleapis.com/ezyagric-media" + animalImage }}' class="img-fluid" alt="{{animalImage}}" />
                    </div>
                    <div class="col-md-6">
                      <label for="photo">Upload New Image</label>
                    <input type="file" value="CHOOSE FILE" name="photo" class="form-control change-files file-input"
                      (change)="changeImage($event)" accept="image/png, image/jpeg, image/jpg" />
                    </div>
                  </div>
                </div>
              </div>
              </div>

              <div class="text-align-right">
                <button type="submit" class="submit-input-btn ui-btn" >
                  <span *ngIf="loading" class="spinner-border spinner-border-md
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                   <i class="fa fa-check text-success "></i> Save changes
                  </span>
                </button>
              </div>
            </form>
    </div>

    <div id="animal" class="tabcontent" style="display: none;">
      <div class="row my-2" *ngIf="!isLoadingAnimalInfo">
        <div class="col-md-auto col-12">
          <div class="h-100 d-flex align-items-center ">
          <h3 class="page-subtitle">Animal Info</h3>
          <button class="btn btn-primary btn-sm ml-3" data-toggle="modal"
          data-target="#animalModal">
            <span>
              <i class="fa fa-plus"></i>
              Add item
            </span>
          </button>
          </div>
        </div>
        <div class="col"></div>
        <div class="col-12 col-md-auto">
          <div class="searchbox">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              id="searchAnimalInfoBox"
              (keyup)="filterAnimalInfoFunction($event)">
              <span class="fa fa-search"></span>
          </div>
        </div>
      </div>
      <div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingAnimalInfo">
        <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
      </div>
      <table class="table table-striped- table-bordered table-primary tab-dat" *ngIf="!isLoadingAnimalInfo">
        <thead>
          <tr class="text-uppercase">
            <th scope="col">#</th>
            <th scope="col">Heading</th>
            <th scope="col">Image</th>
            <th scope="col">Status</th>
            <th scope="col">Sub-heading</th>
            <th scope="col">Description</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="filteranimalInfo?.length===0" style="text-align: center;">
            <td colspan="7">No animal information added yet...</td>
          </tr>
          <tr *ngFor="let row of filteranimalInfo | paginate: { id: 'paginate1', itemsPerPage: count, currentPage: animalPage };
          let i = index">
            <td>{{ (animalPage - 1) * count + i + 1 }}</td>
            <td class="text-primary font-weight-bold">{{ row.purpose }}</td>
            <td>
              <div class="mult_images">
                <div *ngFor="let photo of row.media">
                  <div class="img-holder mb-1" *ngIf="photo.photo_url">
                    <img src='{{ "https://storage.googleapis.com/ezyagric-media" + photo.photo_url }}' alt="{{row.animal}}"
                    />
                  </div>
                </div>
              </div>
            </td>
            <td
              [className]="row.status"
            >
              <span class="dot mr-2"></span>
              {{row.status | titlecase}}
            </td>
            <td><b>{{ row.title }}</b></td>
            <td [innerHTML]="row.description | truncateText:50" ></td>
            <td>
              <div class="dropdown">
                <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  ACTION
                </button>
                <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                  <button
                    class="dropdown-item suspend"
                    data-toggle="modal"
                    data-target="#editAnimalInfoModal"
                    (click)="editAnimalInfoDetails( row )"
                  >
                    View details
                  </button>
                  <button
                    *ngIf="checkPublishStatus('inactive',row)"
                    class="dropdown-item suspend text-success"
                    data-toggle="modal"
                    data-target="#publishModal"
                    (click)="editAnimalInfoDetails( row )"
                  >
                    Publish
                  </button>
                  <button
                    *ngIf="checkPublishStatus('active',row)"
                    class="dropdown-item suspend text-danger"
                    data-toggle="modal"
                    data-target="#publishModal"
                    (click)="editAnimalInfoDetails( row )"
                  >
                    Unpublish
                  </button>
                </div>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="!isLoadingAnimalInfo">
          <nav aria-label="Page navigation example">
            <pagination-controls id="paginate1" (pageChange)="animalPage = $event"></pagination-controls>
          </nav>
        </div>
      </div>

      <div id="disease" class="tabcontent" style="display: none;">
        <app-animal-diagnosis-table
          [category]="category"
          [isLoadingDiagnosis]="isLoadingDiagnosis"
          [diseaseData]="diseaseData"
          [diseaseDataFilter]="diseaseDataFilter"
          (singleDiagViewData)="getSingleDiagnosisViewData($event)"
          (isEditingDiagnosis)="getEditingStatus($event)"
        >
        </app-animal-diagnosis-table>
      </div>

      <div id="pest" class="tabcontent" style="display: none;">
        <app-animal-diagnosis-table
          [category]="category"
          [pestData]="pestData"
          [isLoadingDiagnosis]="isLoadingDiagnosis"
          [pestDataFilter]="pestDataFilter"
          (singleDiagViewData)="getSingleDiagnosisViewData($event)"
          (isEditingDiagnosis)="getEditingStatus($event)"
        >
        </app-animal-diagnosis-table>
      </div>
    </div>

    <!-- beginning of add animalinfo modal -->
    <div class="modal fade" id="animalModal" style="overflow: auto;">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" (click)="onClickOutside()">
        <div class="card modal-content container-fluid">
            <div class="modal-header no-border">
                <h5 class="modal-title text text-primary" style="font-weight: bold;" id="modal-basic-title">Add Animal Info</h5>
                <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" (click)="resetModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body animal-view-details">
              <span class="text-center alert alert-danger" *ngIf="serverError">{{ message }}</span>
              <div class="container-fluid">
                <form
                  (ngSubmit)="addAnimalInfo()"
                  [formGroup]="addAnimalInfoForm"
                  class="px-2 py-2"
                  id="addAnimalForm"
                >

                <div class="form-group">
                  <label for="purpose">Heading</label>
                  <input
                    type="text"
                    class="form-control change-input-field"
                    placeholder="Purpose"
                    formControlName="purpose"
                  />
                  <div
                    *ngIf="(addAnimalInfoForm.get('purpose').dirty ||
                      addAnimalInfoForm.get('purpose').touched)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="addAnimalInfoForm.get('purpose').invalid &&
                    addAnimalInfoForm.get('purpose').errors.required">
                      Please the heading is required
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="title">Sub-Heading</label>
                  <input
                    type="text"
                    class="form-control change-input-field"
                    placeholder="Title"
                    formControlName="title"
                  />
                </div>

                <div class="form-group">
                  <label for="description">Description</label>
                    <quill-editor
                      formControlName="description"
                      [modules]="quillConfig"
                      [styles]="editorStyle"
                    >
                    </quill-editor>
                </div>

                <div class="form-group">
                  <label for="purpose">Position on app</label>
                  <input
                    type="number"
                    class="form-control change-input-field"
                    formControlName="position"
                    placeholder="Position sub heading should appear on app"
                  />
                  <div
                    *ngIf="(addAnimalInfoForm.get('position').dirty ||
                      addAnimalInfoForm.get('position').touched)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="addAnimalInfoForm.get('position').invalid &&
                      addAnimalInfoForm.get('position').errors.required">
                      Please the position is required
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="media">Media</label>
                  <div class="mult_images">
                    <div formArrayName="media" *ngFor="let media of addAnimalMedia().controls; let i = index">
                      <div class="form-group" [formGroupName]="i">
                        <div class="card" style="width: 20rem;">
                          <div class="card-body">
                            <input
                              type="file"
                              class="form-control file-input"
                              (change)="changeFiles($event, i)"
                              accept="image/png, image/jpeg, image/jpg"
                            />
                            <br>
                            <div *ngIf="media.value.video_url">
                              <video id='{{"add-animalvid-tag"+i}}' width="100%" height="150px" controls muted>
                                <source src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.video_url }}'>
                                Your browser does not support the video tag.
                              </video>
                            </div>
                            <p-dropdown
                              [options]="videosToSelect"
                              formControlName="video_url"
                              placeholder="Select a video"
                              [optionLabel]="label"
                              filter="true"
                              [style]="{'width':'100%', 'height': '35px'}"
                              (onChange)="onAnimalVideoChange($event, i)"
                            >
                            </p-dropdown>
                            <br>
                            <input
                              type="number"
                              class="form-control mt-3"
                              formControlName="position"
                              placeholder="Position"
                            >
                            <div
                              *ngIf="(media.get('position').dirty ||
                              media.get('position').touched)"
                              class="text-danger error_message"
                            >
                              <span *ngIf="media.get('position').invalid &&
                              media.get('position').errors.required">
                                Please the position is required
                              </span>
                            </div>
                            <br>
                            <div class="row">
                              <div class="col-md-3">
                                <button
                                  type="button"
                                  class="btn btn-info btn-sm"
                                  (click)="removeAddAnimalMedia(i)"
                                >Remove</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div (click)="addAnimalInfoMedia()" class="col">
                      <div class="card bg-light" id="add-card">
                        <div class="card-body text-center">
                          <i class="fas fa-plus"></i>
                          <p class="card-text">Add Media</p>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                    </div>
                  </div>
                </div>

                <div class="form-group" *ngIf="countryName==='Uganda'">
                  <label for="inputs">Inputs</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "inputsToSelect"
                    id="selectInput"
                    formControlName="input"
                  >
                  </p-multiSelect>
                </div>
                <div class="form-group">
                  <label for="inputs">Services</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "servicesToSelect"
                    id="selectService"
                    formControlName="service"
                  >
                  </p-multiSelect>
                </div>
                <br>
                <div>
                  <button type="submit" class="btn btn-primary float-right" [disabled]="!addAnimalInfoForm.valid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm
                      text-white change-loading mx-auto" role="status"></span>
                    <span *ngIf="loading" class="mx-2">Loading...</span>
                    <span *ngIf="!loading">
                      Save changes
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Beginning of edit animal info modal -->
    <div class="modal fade" id="editAnimalInfoModal" style="overflow: auto;">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="card modal-content container-fluid">
            <div class="modal-header no-border">
                <h5 class="modal-title text text-primary" style="font-weight: bold;" id="modal-basic-title">Edit Animal info</h5>
                <div class="float-right">
                  <a
                    class="btn btn-danger text-white"
                    data-dismiss="modal"
                    data-toggle="modal"
                    data-target="#deleteModal"
                    (click)="deleteAnimalInfoDetails( editAnimalInfoData )"
                    *ngIf="!editAnimalInfoisSuccess"
                  >Delete</a>
                  <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close" (click)="resetEditModal()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
            </div>

            <div class="modal-body animal-view-details">
              <span class="text-center alert alert-danger" *ngIf="editAnimalError">{{ message }}</span>
              <div class="container-fluid" *ngIf="editAnimalInfoData">
                <form
                  (ngSubmit)="updateAnimalInfo(editAnimalInfoData.id)"
                  class="px-2 py-2"
                  id="updateAnimalInfo"
                  [formGroup]="updateAnimalInfoForm"
                >

                <div class="form-group">
                  <label for="purpose">Purpose</label>
                  <input
                    type="text"
                    class="form-control change-input-field"
                    placeholder="Purpose"
                    formControlName="purpose"
                  />
                  <div
                    *ngIf="(updateAnimalInfoForm.get('purpose').dirty ||
                      updateAnimalInfoForm.get('purpose').touched)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="updateAnimalInfoForm.get('purpose').invalid &&
                      updateAnimalInfoForm.get('purpose').errors.required">
                      Please the heading is required
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="title">Title</label>
                  <input
                    type="text"
                    class="form-control change-input-field"
                    placeholder="Title"
                    formControlName="title"
                  />
                </div>

                <div class="form-group">
                  <label for="description">Description</label>
                    <quill-editor
                      formControlName="description"
                      [modules]="quillConfig"
                    >
                    </quill-editor>
                </div>

                <div class="form-group">
                  <label for="title">Current position on app</label>
                  <input
                    type="number"
                    class="form-control change-input-field"
                    placeholder="Position on app"
                    formControlName="position"
                  />
                  <div
                    *ngIf="(updateAnimalInfoForm.get('position').dirty ||
                      updateAnimalInfoForm.get('position').touched)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="updateAnimalInfoForm.get('position').invalid &&
                      updateAnimalInfoForm.get('position').errors.required">
                      Please the position is required
                    </span>
                  </div>
                </div>

                <div class="form-group">
                  <label for="media">Media</label>
                  <div class="mult_images">
                    <div formArrayName="media" *ngFor="let media of editAnimalMedia().controls; let i = index">
                      <div class="form-group" [formGroupName]="i">
                        <div class="card" style="width: 20rem;">
                          <div class="card-body">
                            <div *ngIf="media.value.photo_url">
                              <img
                                class="card-img-top"
                                src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.photo_url }}'
                                alt="animal image"
                                style="width: 100%; height: 100px;"
                              >
                            </div>
                            <input
                              type="file"
                              class="form-control file-input mt-1"
                              (change)="changeFiles($event, i)"
                              accept="image/png, image/jpeg, image/jpg"
                            />
                            <br>
                            <div *ngIf="media.value.video_url">
                              <video id='{{"edit-animalvid-tag"+i}}' width="100%" height="150px" controls muted>
                                <source src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.video_url }}'>
                                Your browser does not support the video tag.
                              </video>
                            </div>
                            <p-dropdown
                              [options]="videosToSelect"
                              formControlName="video_url"
                              placeholder="Select a video"
                              [optionLabel]="label"
                              filter="true"
                              [style]="{'width':'100%', 'height': '35px'}"
                              (onChange)="onAnimalVideoChange($event, i)"
                            >
                            </p-dropdown>
                            <br>
                            <input
                              type="number"
                              class="form-control mt-3"
                              formControlName="position"
                              placeholder="Position"
                            >
                            <div
                              *ngIf="(media.get('position').dirty ||
                              media.get('position').touched)"
                              class="text-danger error_message"
                            >
                              <span *ngIf="media.get('position').invalid &&
                              media.get('position').errors.required">
                                Please the position is required
                              </span>
                            </div>
                            <br>
                            <div class="row">
                              <div class="col-md-3">
                                <button
                                  type="button"
                                  class="btn btn-info btn-sm"
                                  (click)="removeEditAnimalMedia(i)"
                                >Remove</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div (click)="editAnimalInfoMedia()" class="col">
                      <div class="card bg-light" id="add-card">
                        <div class="card-body text-center">
                          <i class="fas fa-plus"></i>
                          <p class="card-text">Add Media</p>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                    </div>
                  </div>
                </div>

                <div class="form-group" *ngIf="countryName==='Uganda'">
                  <label for="inputs">Inputs</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "inputsToSelect"
                    id="selectInput"
                    formControlName="input"
                  >
                  </p-multiSelect>
                  <div
                    class="form-control reco-alert"
                    id="animalInputs"
                  >
                    <div
                      class="alert alert-primary alert-dismissible fade show"
                      style="width: 80%; padding: 2px;"
                      role="alert"
                      *ngFor="let input of savedInputs; let i = index"
                    >
                        {{ input.name }}
                      <button
                        type="button"
                        class="close close-btn"
                        data-dismiss="alert"
                        aria-label="Close"
                        (click) = "removeInput(i)"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="inputs">Services</label>
                  <p-multiSelect
                    autoWidth="false"
                    [style]="{'width':'100%', 'height': '35px'}"
                    [options] = "servicesToSelect"
                    id="selectService"
                    formControlName="service"
                  >
                  </p-multiSelect>
                  <div
                    class="form-control reco-alert"
                    id="animalServices"
                  >
                    <div
                      class="alert alert-primary alert-dismissible fade show"
                      style="width: 80%; padding: 2px;"
                      role="alert"
                      *ngFor="let service of savedServices | falsyFilter; let i = index;"
                    >
                        {{ service }}
                      <button
                        type="button"
                        class="close close-btn"
                        data-dismiss="alert"
                        aria-label="Close"
                        (click) = "removeService(i)"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <button type="submit" class="btn btn-primary float-right" [disabled]="!updateAnimalInfoForm.valid">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm
                      text-white change-loading" role="status"></span>
                    <span *ngIf="loading" class="mx-2">Loading...</span>
                    <span *ngIf="!loading">
                      Save changes
                    </span>
                  </button>
                </div>
              </form>
                </div>
            </div>
        </div>
      </div>
    </div>

    <!-- beginning of delete animalinfo data -->
    <div class="modal fade" id="deleteModal">
      <div class="modal-dialog change-modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" *ngIf="deleteAnimalInfoData">
          <div class="modal-header no-border">
            <h5 class="modal-title text-primary" id="exampleModalLabel">Delete Animal Info</h5>
            <button
              type="button"
              class="close close-btn"
              data-dismiss="modal"
              aria-label="Close"
              (click)="resetDeleteAnimalInfoModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            Are you sure you want to delete <span class="font-weight-bold">"{{ deleteAnimalInfoData.purpose }}"</span> permanently?
          </div>
          <div class="modal-footer no-border">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="deleteAnimalInfo(deleteAnimalInfoData.id)"
            >
              <span
                *ngIf="loading"
                class="spinner-border spinner-border-sm text-white
                  update-loading"
                role="status"
              ></span>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Add diagnosis modal -->
    <div class="modal fade" id="addDiagnosisModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true" style="overflow: auto;">
      <div class="modal-dialog modal-lg" role="document" (click)="onClickOutside()">
        <div class="modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;">Add {{ category }}</h5>
            <button type="button" class="close close-btn"  aria-hidden="true" data-dismiss="modal" (click)="closeAddDiagModal()">&times;</button>
          </div>
          <div class="modal-body">
            <form
              class="form"
              (ngSubmit)="addDiagnosis()"
              id="diagnosisForm"
              [formGroup]="addDiagnosisForm"
            >
              <div class="form-group">
                <label for="diagnosisName">{{ category }} name</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="name"
                >
                  <div
                    *ngIf="(addDiagnosisForm.get('name').dirty || addDiagnosisForm.get('name').touched)"
                    class="text-danger error_message"
                  >
                    <span *ngIf="addDiagnosisForm.get('name').invalid && addDiagnosisForm.get('name').errors.required">
                      Please the name is required
                    </span>
                  </div>
              </div>

              <div class="form-group">
                <label for="diagnosisMedia">Media</label>
                <div class="mult_images">
                  <div formArrayName="media" *ngFor="let media of addDiagnosisMedia().controls; let i = index">
                    <div class="form-group" [formGroupName]="i">
                      <div class="card" style="width: 20rem;">
                        <div class="card-body">
                          <input
                            type="file"
                            class="form-control file-input"
                            (change)="changeFiles($event, i)"
                            accept="image/png, image/jpeg, image/jpg"
                          />
                          <br>
                          <div *ngIf="media.value.video_url">
                            <video id='{{"add-diagvid-tag"+i}}' width="100%" height="150px" controls muted>
                              <source src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.video_url }}'>
                              Your browser does not support the video tag.
                            </video>
                          </div>
                          <p-dropdown
                            [options]="videosToSelect"
                            formControlName="video_url"
                            placeholder="Select a video"
                            [optionLabel]="label"
                            filter="true"
                            [style]="{'width':'100%', 'height': '35px'}"
                            (onChange)="onDiagVideoChange($event, i)"
                          >
                          </p-dropdown>
                          <br>
                          <input
                            type="number"
                            class="form-control mt-3"
                            formControlName="position"
                            placeholder="Position"
                          >
                          <br>
                          <div class="row">
                            <div class="col-md-3">
                              <button
                                type="button"
                                class="btn btn-info btn-sm"
                                (click)="removeAddDiagMedia(i)"
                              >Remove</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div (click)="addDiagMedia()" class="col">
                    <div class="card bg-light" id="add-card">
                      <div class="card-body text-center">
                        <i class="fas fa-plus"></i>
                        <p class="card-text">Add Media</p>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                  </div>
                </div>
              </div>

              <div class="form-group" *ngIf="category === 'Disease'">
                <label for="diagnosisCause">Cause</label>
                <input
                  type="text"
                  class="form-control"
                  id="diagnosisCause"
                  placeholder="E.g. Bacteria"
                  formControlName="cause"
                >
              </div>
              <div class="form-group">
                <label for="position">Position on app</label>
                <input
                  type="number"
                  class="form-control"
                  placeholder="Position {{category}} should appear on app"
                  formControlName="position"
                />
                <div
                  *ngIf="(addDiagnosisForm.get('position').dirty ||
                    addDiagnosisForm.get('position').touched)"
                  class="text-danger error_message"
                >
                  <span *ngIf="addDiagnosisForm.get('position').invalid &&
                    addDiagnosisForm.get('position').errors.required">
                    Please the position is required
                  </span>
                </div>
              </div>

              <div>
                <label for="diseaseExplanation">Description</label>
                <quill-editor
                  id="diseaseExplanation"
                  [modules]="quillConfig"
                  formControlName="explanation"
                  [styles]="editorStyle"
                >
                </quill-editor>
              </div>
              <div>
                <label for="diagnosisControl">Prevention and Control</label>
                <quill-editor
                id="diagnosisControl"
                [modules]="quillConfig"
                formControlName="control"
                [styles]="editorStyle"
                >
                </quill-editor>
              </div>
              <div class="form-group" *ngIf="countryName==='Uganda'">
                <label for="inputs">Inputs</label>
                <p-multiSelect
                  autoWidth="false"
                  [style]="{'width':'100%', 'height': '35px'}"
                  [options] = "inputsToSelect"
                  id="selectInput"
                  formControlName="input"
                >
                </p-multiSelect>
              </div>
              <div class="form-group">
                <label for="inputs">Services</label>
                <p-multiSelect
                  autoWidth="false"
                  [style]="{'width':'100%', 'height': '35px'}"
                  [options] = "servicesToSelect"
                  id="selectInput"
                  formControlName="service"
                >
                </p-multiSelect>
              </div>
              <br>
              <div>
                <button
                  type="submit"
                  class="btn btn-primary float-right"
                  [disabled]="!addDiagnosisForm.valid"
                >
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Save changes
                </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

     <!-- Edit diagnosis Model -->
    <div class="modal fade" id="editDiagnosisModal" tabindex="-1" role="dialog" aria-hidden="true" style="overflow: auto;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content container-fluid">
          <div class="modal-header no-border">
            <h5 class="modal-title text text-primary" style="font-weight: bold;">Edit {{ category }}</h5>
            <div class="float-right">
              <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#deleteDiagModal" (click)="closeEditDiagModal()">Delete {{ category }}</button>
              <button type="button" class="close close-btn"  data-dismiss="modal" (click)="closeEditDiagModal()">&times;</button>
            </div>
          </div>
          <div class="modal-body">
            <form
              *ngIf="singleDiagnosisViewData"
              class="form"
              (ngSubmit)="editDiagnosis()"
              id="editForm"
              [formGroup]="editDiagnosisForm"
            >
              <div class="form-group">
                <label for="diagnosisName">{{ category }} name</label>
                  <input
                    type="text"
                    class="form-control change-input-field"
                    formControlName="name"
                  >
                    <div
                      *ngIf="(editDiagnosisForm.get('name').dirty || editDiagnosisForm.get('name').touched)"
                      class="text-danger error_message"
                    >
                      <span *ngIf="editDiagnosisForm.get('name').invalid && editDiagnosisForm.get('name').errors.required">
                        Please the name is required
                      </span>
                    </div>
              </div>
              <div class="form-group">
                <label for="diagnosisMedia">Media</label>
                <div class="mult_images">
                  <div formArrayName="media" *ngFor="let media of editDiagnosisMedia().controls; let i = index">
                    <div class="form-group" [formGroupName]="i">
                      <div class="card" style="width: 20rem;">
                        <div class="card-body">
                          <div *ngIf="media.value.photo_url">
                            <img
                              class="card-img-top"
                              src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.photo_url }}'
                              alt="{{ category }} image"
                              style="width: 100%; height: 100px;"
                            >
                          </div>
                          <input
                            type="file"
                            class="form-control file-input mt-1"
                            (change)="changeFiles($event, i)"
                            accept="image/png, image/jpeg, image/jpg"
                          />
                          <br>
                          <div *ngIf="media.value.video_url">
                            <video id='{{"edit-diagvid-tag"+i}}' width="100%" height="150px" controls muted>
                              <source src='{{ "https://storage.googleapis.com/ezyagric-media" + media.value.video_url }}'>
                              Your browser does not support the video tag.
                            </video>
                          </div>
                          <p-dropdown
                            [options]="videosToSelect"
                            formControlName="video_url"
                            placeholder="Select a video"
                            [optionLabel]="label"
                            filter="true"
                            [style]="{'width':'100%', 'height': '35px'}"
                            (onChange)="onDiagVideoChange($event, i)"
                          >
                          </p-dropdown>
                          <br>
                          <input
                            type="number"
                            class="form-control mt-3"
                            formControlName="position"
                            placeholder="Position"
                          >
                          <div
                            *ngIf="(media.get('position').dirty ||
                            media.get('position').touched)"
                            class="text-danger error_message"
                          >
                            <span *ngIf="media.get('position').invalid &&
                            media.get('position').errors.required">
                              Please the position is required
                            </span>
                          </div>
                          <br>
                          <div class="row">
                            <div class="col-md-3">
                              <button
                                type="button"
                                class="btn btn-info btn-sm"
                                (click)="removeEditDiagMedia(i)"
                              >Remove</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div (click)="editDiagMedia()" class="col">
                    <div class="card bg-light" id="add-card">
                      <div class="card-body text-center">
                        <i class="fas fa-plus"></i>
                        <p class="card-text">Add Media</p>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                  </div>
                </div>
              </div>

              <div class="form-group" *ngIf="category === 'Disease'">
                <label for="diagnosisCause">Cause</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="E.g. Bacteria"
                  formControlName="cause"
                >
              </div>
              <div class="form-group">
                <label for="title">Current position on app</label>
                <input
                  type="number"
                  class="form-control change-input-field"
                  placeholder="Position on app"
                  formControlName="position"
                />
                <div
                  *ngIf="(editDiagnosisForm.get('position').dirty ||
                    editDiagnosisForm.get('position').touched)"
                  class="text-danger error_message"
                >
                  <span *ngIf="editDiagnosisForm.get('position').invalid &&
                    editDiagnosisForm.get('position').errors.required">
                    Please the position is required
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="diseaseExplanation">Description</label>
                <quill-editor
                  [modules]="quillConfig"
                  formControlName="explanation"
                  [styles]="editorStyle"
                >
                </quill-editor>
              </div>
              <div class="form-group">
                <label for="diagnosisControl">Prevention and Control</label>
                <quill-editor
                [modules]="quillConfig"
                formControlName="control"
                [styles]="editorStyle"
                >
                </quill-editor>
              </div>
              <div class="form-group" *ngIf="countryName==='Uganda'">
                <label for="inputs">Inputs</label>
                <p-multiSelect
                  autoWidth="false"
                  [style]="{'width':'100%', 'height': '35px'}"
                  [options] = "inputsToSelect"
                  id="selectInput"
                  formControlName="input"
                >
                </p-multiSelect>
                <div
                  class="form-control reco-alert"
                  id="diagInputs"
                >
                  <div
                    class="alert alert-primary alert-dismissible fade show"
                    style="width: 80%; padding: 2px;"
                    role="alert"
                    *ngFor="let input of savedInputs; let i = index"
                  >
                      {{ input.name }}
                    <button
                      type="button"
                      class="close close-btn"
                      data-dismiss="alert"
                      aria-label="Close"
                      (click) = "removeInput(i)"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  </div>
              </div>
              <div class="form-group">
                <label for="inputs">Services</label>
                <p-multiSelect
                  autoWidth="false"
                  [style]="{'width':'100%', 'height': '35px'}"
                  [options] = "servicesToSelect"
                  id="selectInput"
                  formControlName="service"
                >
                </p-multiSelect>
                <div
                  class="form-control reco-alert"
                  id="diagServices"
                >
                  <div
                    class="alert alert-primary alert-dismissible fade show"
                    style="width: 80%; padding: 2px;"
                    role="alert"
                    *ngFor="let service of savedServices | falsyFilter; let i = index;"
                  >
                      {{ service }}
                    <button
                      type="button"
                      class="close close-btn"
                      data-dismiss="alert"
                      aria-label="Close"
                      (click) = "removeService(i)"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
              <br>
              <div>
                <button
                  type="submit"
                  class="btn btn-primary float-right"
                  [disabled]="!editDiagnosisForm.valid"
                >
                <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
                </span>
                <span *ngIf="loading" class="mx-2">Loading...</span>
                <span *ngIf="!loading">
                  Save changes
                </span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Diagnosis modal-->
    <div class="modal fade" id="deleteDiagModal" tabindex="-1" role="dialog" aria-labelledby="deleteDiagnosisModal"
     aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" *ngIf="singleDiagnosisViewData">
          <div class="modal-header no-border">
            <h5 class="modal-title text-primary" id="deleteDiagnosisModal">Delete {{ category }}?</h5>
            <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
             </button>
          </div>

          <div class="modal-body">
            Are you sure you want to delete <span class="font-weight-bold">"{{ singleDiagnosisViewData.name }}"</span> permanently?
          </div>
          <div class="modal-footer no-border">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" (click)="deleteDiagnosis(singleDiagnosisViewData.id)">
              <span
                *ngIf="loading"
                class="spinner-border spinner-border-sm text-white
                  update-loading"
                role="status"
              ></span>
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Publish or unpublish content modal-->
  <div class="modal fade" id="publishModal" tabindex="-1" role="dialog" aria-labelledby="publishModal"
  aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
     <div class="modal-content">
       <div class="modal-header no-border">
        <h5 class="modal-title text-primary">
          <span *ngIf="publishStatus==='inactive'">Publish</span>
          <span *ngIf="publishStatus==='active'">Unpublish</span>
          Content
        </h5>
         <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
           <span aria-hidden="true">&times;</span>
          </button>
       </div>
       <div class="modal-body">
        Are you sure you want to <span class="font-weight-bold" *ngIf="publishStatus==='inactive'">publish</span>
        <span class="font-weight-bold" *ngIf="publishStatus==='active'">unpublish</span> this content?
       </div>
       <div class="modal-footer no-border">
         <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
         <button
           type="button"
           class="btn btn-primary"
           (click)="publishContent(publishId)"
         >
           <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
           </span>
           <span *ngIf="loading" class="mx-2">Loading...</span>
           <span *ngIf="!loading">
             Yes
           </span>
         </button>
       </div>
     </div>
    </div>
  </div>
</div>
